import { RiskyEmailSurveyModal } from "components/risky-email-survey-handler/risky-email-survey-modal";
import { useEffect, useState } from "react";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

export const RiskyEmailSurveyHandler = () => {
  const [showModal, showModalSet] = useState(false);
  const feedbackRiskyShow = useAppSelector(
    authNewSelectors.feedbackRiskyShowGet,
  );
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);
  const isTeamOwner = useAppSelector(authNewSelectors.userIsTeamOwner);

  useEffect(() => {
    if (!isLoggedIn || !isTeamOwner || !feedbackRiskyShow) {
      return;
    }

    showModalSet(true);
  }, [isLoggedIn, isTeamOwner, feedbackRiskyShow]);

  if (!showModal) {
    return null;
  }

  return <RiskyEmailSurveyModal onClose={() => showModalSet(false)} />;
};
